<div 
	*ngIf="categoryNotFound" 
	id="maincontent" 
	tabindex="0" 
	[ngClass]="{'app-light-theme': !themeService.isDark, 'app-dark-theme': themeService.isDark}"
>
	<h1>{{ 'Reports.CategoryNotFound' | translate: { categoryKey: categoryKey } }}</h1>
</div>
<ng-container *ngIf="!categoryNotFound">
    <section class="category-description" fxFlex="auto" fxLayout="column" fxLayoutGap="20px" [ngClass]="{'app-light-theme': !themeService.isDark, 'app-dark-theme': themeService.isDark}" aria-labelledby="maincontent">

        <div><img aria-hidden="true" alt="" src="assets/img/{{ (category | async)?.getIcon() }}_cat_icon.svg" /></div>
        <h1 class="title" id="maincontent" tabindex="0">{{ (category | async)?.title}}</h1>
        <div tabindex="0">{{ (category | async)?.objective}}</div>
    </section>
    <section *ngIf="reports.length>0" [attr.aria-label]="'Reports.ReportList' | translate">
        <app-report-listing [reports]="reports"></app-report-listing>
    </section>
</ng-container>